import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { State } from '../../../../redux/reducers';
import { getDirectSessionBanner, DirectResumeSession, DirectLoggedOut } from '@uxdf/direct-shared-lib';
import { Subscription } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  standalone: false,
  selector: 'app-direct-timeout-banner',
  templateUrl: './direct-timeout-banner.component.html'
})
export class DirectTimeoutBannerComponent implements OnInit, OnDestroy {
  @ViewChild('modalTemplate', { static: true }) private readonly modalTemplate: ElementRef;
  counter: number;
  private subscriptions$: Subscription;
  private isShown = false;
  private modalRef: NgbModalRef;

  constructor(private readonly store: Store<State>, private readonly modalService: NgbModal) {}
  ngOnInit() {
    this.subscriptions$ = this.store.pipe(select(getDirectSessionBanner)).subscribe(bannerState => {
      this.counter = bannerState.counter;
      if (bannerState.shownBanner && !this.isShown) {
        this.isShown = true;
        this.modalRef = this.modalService.open(this.modalTemplate, {
          centered: true,
          container: 'body',
          backdrop: 'static'
        });
        this.modalRef.result.then(
          () => {
            // continue callback
            this.store.dispatch(new DirectResumeSession());
            this.isShown = false;
          },
          () => {
            // logout callback
            this.store.dispatch(new DirectLoggedOut());
            this.isShown = false;
          }
        );
      }
      if (this.modalRef && !bannerState.shownBanner) {
        this.modalRef.close();
        this.isShown = false;
      }
    });
  }

  ngOnDestroy(): void {
    this.subscriptions$.unsubscribe();
  }
}
